import React, { FC } from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { logger } from '@fiverr-private/obs';
import { Author as AuthorType } from '../../../../shared/types';
import { Author } from '../Author';

export const AboutAuthor: FC<AuthorType & { variant?: 'card' | 'sidebar' }> = (props) => {
  const { photo, authorName, heading, variant } = props;

  if (!photo && variant !== 'sidebar') {
    logger.error(`Author photo is missing for ${authorName}`, { ...props });
  }

  return <Author {...props} heading={heading || translate<string>('fiverr_guides.guide.author.heading')} />;
};
